export const COOKIE_NAME = '.ASCD_okta_piano'
export const ACTIVATE_COOKIE_NAME = '_pc_ssomo'
export const SALESFORCE_COOKIE = '.ASCD_salesforce'
export const WITSBY_PAYWALL_COOKIE = 'isELBadgeMember'
export default COOKIE_NAME
